module.exports = __webpack_public_path__ + "photo1.png?bcfd8cabdd0fc9975a43fa8c8fcbd56d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo1.png
// module id = 53
// module chunks = 0